import { render, staticRenderFns } from "./OceanAgeChart.vue?vue&type=template&id=7a093f7c&scoped=true&"
import script from "./OceanAgeChart.vue?vue&type=script&lang=js&"
export * from "./OceanAgeChart.vue?vue&type=script&lang=js&"
import style0 from "./OceanAgeChart.vue?vue&type=style&index=0&id=7a093f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a093f7c",
  null
  
)

export default component.exports